"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactFilm = require("react-film");

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Localize = require("../Localization/Localize");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _CarouselFilmStrip = _interopRequireDefault(require("./CarouselFilmStrip"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'relative'
});

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var language = _ref.language,
      styleSet = _ref.styleSet;
  return {
    language: language,
    styleSet: styleSet
  };
})(function (_ref2) {
  var activity = _ref2.activity,
      children = _ref2.children,
      language = _ref2.language,
      styleSet = _ref2.styleSet,
      timestampClassName = _ref2.timestampClassName;
  var filmStyleSet = (0, _reactFilm.createBasicStyleSet)({
    cursor: null
  });
  return _react.default.createElement(_reactFilm.Composer, {
    numItems: _react.default.Children.count(children)
  }, _react.default.createElement(_reactFilm.Context.Consumer, null, function (_ref3) {
    var scrollBarWidth = _ref3.scrollBarWidth;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(ROOT_CSS + '', filmStyleSet.carousel + '')
    }, _react.default.createElement(_CarouselFilmStrip.default, {
      activity: activity,
      timestampClassName: timestampClassName
    }, children), scrollBarWidth !== '100%' && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactFilm.Flipper, {
      "aria-label": (0, _Localize.localize)('Left', language),
      className: (0, _classnames.default)(styleSet.carouselFlipper + '', filmStyleSet.leftFlipper + ''),
      mode: "left"
    }, _react.default.createElement("div", {
      className: "button"
    }, "<")), _react.default.createElement(_reactFilm.Flipper, {
      "aria-label": (0, _Localize.localize)('Right', language),
      className: (0, _classnames.default)(styleSet.carouselFlipper + '', filmStyleSet.rightFlipper + ''),
      mode: "right"
    }, _react.default.createElement("div", {
      className: "button"
    }, ">"))));
  }));
});

exports.default = _default;